module.exports = __webpack_public_path__ + "assets/24957ac9ec6a4965f05e67aeb5dbd045.png";